<template>
  <div style="height: 500px" class="overflow-auto">
    <div class="row">
      <!-- Left Column -->
      <div class="col-lg-4 col-md-4 col-sm-12">
        <h6>{{ holidayDetails.user.fullName }}</h6>
        <p class="mb-4">{{ holidayDetails.startDate }} - {{ holidayDetails.endDate }}</p>
        <div v-if="holidayDetails.specialLeave">
          <h6>Grund der Beantragung:</h6>
          <div v-html="holidayDetails.reasonForLeaving"></div>
        </div>
      </div>

      <div class="col-lg-4 col-md-4 col-sm-12">
        <h6>Status</h6>
        <p>{{ holidayDetails.statusTranslated }}</p>
      </div>

      <!-- Right Column -->
      <div class="col-lg-4 col-md-4 col-sm-12">
        <h6>Tage</h6>
        <div v-for="(item, index) in holidayDetails.items" :key="index">
          <p>
            {{ item.date }}
            <span v-if="holidayDetails.status === 'approved' && item.year"> - {{ item.year }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  holidayDetails: {
    type: Object,
    required: true,
  },
});
</script>

<style scoped>

</style>